import React from 'react'
import Icon from 'decorators/Icon'

// eslint-disable-next-line react/prop-types
const IconTriangle = ({ t, className, fill }) => (
  <svg width={9} height={6} className={className}>
    <title>{t('Triangle')}</title>
    <path fill={fill} fillRule='evenodd' d='M.75.25l7.5.05-3.777 4.95z' />
  </svg>
)

export default Icon(IconTriangle)
